import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgArrowMiniLeft32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" d="M18.957 10.646a.5.5 0 0 0-.707 0L12.897 16l5.353 5.354a.5.5 0 0 0 .707-.708L14.311 16l4.646-4.646a.5.5 0 0 0 0-.708" /></SvgIcon>;
};
const Memo = memo(SvgArrowMiniLeft32);
export default Memo;